<template>
    <div class="note-login-id">
      下記のログインIDは管理画面へのログイン時に必要な情報です。<br>
      登録が完了すると上記で入力したメールアドレス宛に、<br>
      初期パスワードとログインIDを記載した通知メールが自動で届きます。
  </div>
</template>
